export default () => ({
  fullWidth: {
    width: '100%',
  },
})
